import cloneDeep from 'lodash/cloneDeep';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ngHelper } from '@cakeiteasy/web-utils';

import { SearchCakesService } from '../../services/search-cakes.service';
import { IFilterModel } from '../../models/i-filter.model';

@Component({
  standalone: false,
  selector: 'search-cakes-panel-mobile',
  templateUrl: './search-cakes-panel-mobile.component.html',
  styleUrls: ['./search-cakes-panel-mobile.component.scss']
})
export class SearchCakesPanelMobileComponent implements OnChanges {
  private _originalFilters: IFilterModel;

  public showFilters: boolean;
  public model: IFilterModel;

  @Input() public filters;
  @Input() public excludingFilters: string[] = [];
  @Input() public showBackBtn: false;
  @Input() public showCloseBtn: true;
  @Output() onClose = new EventEmitter<IFilterModel>();
  @Output() onReset = new EventEmitter<void>();

  public hiddenFilters: any = {};

  constructor(public searchCakes: SearchCakesService) {
  }

  public closeWithoutSaving() {
    this.model = cloneDeep(this._originalFilters);
    this.onClose.emit(this.model);
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'filters', (filters) => {
      this.model = cloneDeep(filters);
      this._originalFilters = cloneDeep(filters);

      this.hiddenFilters = this._getHiddenFilters(this.excludingFilters);
    });
  }

  public productGroupChanged(group) {
    this.model.productGroups.forEach((pg) => {
      pg.checked = pg.value === group.value && group.checked;
    });
  }

  private _getHiddenFilters(excludingFilters: string[]) {
    const result = {};
    excludingFilters.forEach((filterName) => {
      result[filterName] = true;
    });

    return result;
  }
}
